import { Outlet } from 'react-router'
import { observer } from 'mobx-react'
import {
    RoyaltiesStatementsContext,
    useRoyaltiesStatements,
} from '@Scenes/RightsholderScene/RightsholderRoyaltiesStatements/hooks/useRoyaltiesStatements'

const RoyaltiesLayout = () => {
    const royaltiesStatements: RoyaltiesStatementsContext = useRoyaltiesStatements()

    return <Outlet context={royaltiesStatements} />
}

export default observer(RoyaltiesLayout)
